import React from "react";

const UpgradeBanner = ({ type = "question", length = 0, theme, onUpgrade }) => {
  // Determine text based on type
  let typeLabel = "question";
  let typeLabelPlural = "questions";
  
  if (type === "flashcard") {
    typeLabel = "flashcard";
    typeLabelPlural = "flashcards";
  } else if (type === "article") {
    typeLabel = "article";
    typeLabelPlural = "articles";
  }

  return (
    <div
      className="mx-4 mb-6 p-4 rounded-lg border-2 border-dashed"
      style={{
        background: `linear-gradient(135deg, ${theme?.primary?.yellow?.[50] || '#fffbeb'}, ${theme?.primary?.yellow?.[100] || '#fef3c7'})`,
        borderColor: theme?.primary?.yellow?.[300] || '#fcd34d',
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h3
            className="text-lg font-semibold mb-2"
            style={{ color: theme?.primary?.yellow?.[800] }}
          >
            🎯 This is your last free {typeLabel}!
          </h3>
          <p
            className="text-sm"
            style={{ color: theme?.primary?.yellow?.[700] || '#a16207' }}
          >
            Upgrade to premium to access all {length || `thousands of`} {typeLabelPlural} and unlock your full potential.
          </p>
        </div>
        <button
          onClick={onUpgrade}
          style={{
            background: theme?.primary?.yellow?.[600] || '#d97706',
            color: theme?.primary?.gray?.[100],
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '0.5rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          className="hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default UpgradeBanner; 